<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">催促メール定型文選択</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="column-list">
            <label class="list-input-title">取引先</label>
            <div class="list-input-content">
              <input type="text" id="lbl_SupplierName" #lbl_SupplierName readonly [style.width.px]="340"
                value="{{kymw1707Model.supplierName}}">
            </div>
            <label class="list-input-title">定型文を選択</label>
            <div class="list-input-content">
              <select class="combo-box-required" id="cmb_Templates" #cmb_Templates [style.width.px]="340" [tabindex]="0"
                forcedEnabledMode="true" (change)="eventChangeHandler_SelectRemindTemplate($event)"
                [(ngModel)]="kymw1707Model.remindMailTempId">
                <ng-template ngFor let-item [ngForOf]="kymw1707Model.remindMailTempList">
                  <option value="{{item.RemindMailTempId}}">{{item.RemindMailTempId}}</option>
                </ng-template>
              </select>
            </div>
            <label class="list-input-title">催促メール プレビュー</label>
            <div class="list-input-content">
              <div class="preview">
                <label *ngIf="isSelected()">件名</label>
                <div *ngIf="isSelected()">{{kymw1707Model.title}}</div>
                <label *ngIf="isSelected()">本文</label>
                <div *ngIf="isSelected()">
                  <textarea class="readonly-textarea" readonly tabindex="-1" 
                    [(ngModel)]="kymw1707Model.mainText"></textarea>
                </div>
                <label *ngIf="isSelected()">取引先への連絡事項</label>
                <div *ngIf="isSelected()">{{kymw1707Model.supplierAnnouncement}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Update" class="btn-primary" (click)="eventClickHandler_Remind()" [tabindex]="0">催促</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventClickHandler_Close()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>